type Axis = number;
export type Coords = [Axis, Axis];

export abstract class Container {
  abstract render(config: any): Promise<void>;
  abstract onShow(): void;
  abstract onHide(): void;
  abstract onOpen(): void;
  abstract onClose(): void;
  abstract onToggle(): void;
  abstract setMargins(): void;
  abstract setZIndex(): void;
  abstract unmount(): void;
  abstract onTooltipDisplay(coords: Coords | null, label: string): void;
}

export type RenderStyle = 'button' | 'dedicated' | 'fixed' | 'relative';
export type RenderPosition = 'left' | 'right';
export type RenderPositionMap = {
  left: RenderPosition;
  right: RenderPosition;
};

export interface RenderMap {
  button: RenderStyle;
  dedicated: RenderStyle;
  fixed: RenderStyle;
  relative: RenderStyle;
}

export type CompactKeyType = 'compact' | 'trigger' | 'compactV2';
export type MessengerKeyType = 'messenger' | 'messengerV2';

export type PlatformScreen = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};
